import {Injectable} from '@angular/core';
import { Router } from '@angular/router';
import {LocationStrategy} from '@angular/common';
import { UserinfoService } from 'src/app/components/index/service/userinfo.service';

@Injectable()
export class UserData {
  data:any;

  csrf : any;

  userinfo: any;

  biproDataLoaded : boolean = false;
  isBiproDataLoaded():boolean{
    return this.biproDataLoaded;
  }

  setBiproDataLoaded(value:any){
    this.biproDataLoaded = value;
  }


  getCsrf():string{
    return this.csrf;
  }

  setCsrf(cs : any){
    this.csrf = cs;
  }

  constructor(private router:Router,
              private url:LocationStrategy,
              private userinfoService: UserinfoService) {
  }

  setData(data:any) {
    this.data = data;
    console.log("Current user data: " + JSON.stringify(this.data));
  }

  // Loadbar zeigt leider nur ungefähre Zeit, wie lange eine Bipro Anfrage dauern kann, dadurch entsteht auch bei verschiedenen Stages
  //eine andere Ladezeit, Stage T und SI im vergleich zu localhost arbeiten ungefähr 2 mal schneller und bearbeiten anhand vorhandene CPU 10 trheads gleichzeitig.
  // Auf Prod muss es 3 mal schneller sein, da da mehr CPU vorhanden ist.
  // Die ungefähre zeit wurde folgend berechnet: Anzahl Zeilen * 1000 / 1.7vorgangdauer / 100
  //1.9 vorgangsdauer ist ungefähr 1 milisecunde
  getStageMultiplicator():any{
    return (this.url.path().toString().indexOf("maklert.allianz")>-1||this.url.path().toString().indexOf("maklersi.allianz")>-1)?4:
      this.url.path().toString().indexOf("makler.allianz")>-1?6:1;
  }

  isStageP() : boolean{
    return this.url.path().toString().indexOf("makler.allianz") > -1 ? true : false;
  }

  isKraft():any{
     if(this.url.path().toString().indexOf("kraft")>-1){
       return "kraft";
     }
     else if(this.url.path().toString().indexOf("meinkonto")>-1){
       return "meinkonto";
     }
     else if(this.url.path().toString().indexOf("portal")>-1){
       return "portal";
     }
     else{
       return "sach";
     }
  }

  getBensl():string{
    let bensl = null;
    if (this.data) {
      bensl = this.data.bensl;
    }

    if (!bensl) {
      try {
        this.userinfo = this.userinfoService.getUserinfo();
      } catch (e) {
        console.log('[UserData] unable to get userinfo from UserinfoService', e);
      }

      if (this.userinfo) {
        bensl = this.userinfo.bensl || this.userinfo.benslId || null;
        this.setData({
          bensl: bensl,
          vorname: this.userinfo.vorname || this.userinfo.firstName,
          nachname: this.userinfo.nachname || this.userinfo.lastName,
          email: this.userinfo.email,
          benart: this.userinfo.benart,
          csrf: this.userinfo.csrf
        });
      }

    }

    return bensl;
  }
}
